import React from 'react'
import RawTableCell from '@mui/material/TableCell'

const TableCell = ({children, sx, ...p}) => {
    return (
        <RawTableCell sx={{fontSize: '0.75rem', maxWidth: 220, ...sx}} {...p}>
            {children}
        </RawTableCell>
    )
}

export default TableCell
